import _ from 'lodash';
import { createSelector } from 'reselect';

import { getComponentProps } from '../form-designer/selectors/common.selectors';
import { hasSavedSearchUnsavedChanges } from '../saved-search-designer/selectors/editor.selectors';

const getWarnings = (state) => state.warnings;
const getRepositoryDetails = (state) => state.repositoryConfiguration.repositoryDetails || {};
const getOriginalRepositoryDetails = (state) =>
  state.repositoryConfiguration.originalRepositoryDetails || {};

export const getDistributionFor = (state, props) =>
  state.repositoryConfiguration.repositoryDetails?.[props.distributionType]?.distributionFor;
export const getIsDistributionModalOpen = (state) =>
  state.repositoryConfiguration.isDistributionModalOpen;
export const getRepositoryTree = (state) =>
  state.repositoryConfiguration.repositoryDetails?.repositoryTree || [];

export const getRepositoryProp = createSelector(
  [getRepositoryDetails, getComponentProps],
  (repositoryDetails, { propName }) => repositoryDetails[propName]
);

export const getErrorByProp = createSelector(
  [getWarnings, getComponentProps],
  (warnings, { prop }) => {
    return warnings.find((error) => error?.controlInfo?.prop === prop);
  }
);

export const getDistributionTableRows = createSelector(
  [getRepositoryDetails, getWarnings, getComponentProps],
  (repositoryDetails, validationErrors, { tablePath }) => {
    const tableRows = _.get(repositoryDetails, tablePath, []);

    return tableRows.map((item) => ({
      ...item,
      errors: validationErrors.filter((error) => error.instanceId === item.rowId),
    }));
  }
);

export const hasRepositoryUnsavedChanges = createSelector(
  [getRepositoryDetails, getOriginalRepositoryDetails, hasSavedSearchUnsavedChanges],
  (repositoryDetails, originalRepositoryDetails, savedSearchUnsavedChanges) =>
    !_.isEqual(repositoryDetails, originalRepositoryDetails) || savedSearchUnsavedChanges
);

export const hasDistributionUnsavedChanges = createSelector(
  [getRepositoryDetails, getOriginalRepositoryDetails],
  (repositoryDetails, originalRepositoryDetails) => {
    const currentDistributionConfig = {
      viewDistribution: repositoryDetails.viewDistribution,
      adminDistribution: repositoryDetails.adminDistribution,
    };

    const originalDistributionConfig = {
      viewDistribution: originalRepositoryDetails.viewDistribution,
      adminDistribution: originalRepositoryDetails.adminDistribution,
    };

    return !_.isEqual(currentDistributionConfig, originalDistributionConfig);
  }
);
